<template>
  <listing-layout>
    <div slot="heading" class="d-flex justify-content-between align-items-center mb-3">
      <h1 class="h2 mb-0">Pending Expressions Of Interest</h1>
    </div>
    <div slot="content">

      <div class="alert alert-success" v-if="success">{{ success }}</div>
      <div class="alert alert-warning" v-if="error">{{ error }}</div>

      <data-table :dataRows="rows" :dataColumns="columns" :options="options">
        <tableTextTemplate slot-scope="{ row }" slot="expandedHeader" :text="row.first_name + ' ' + row.last_name" :link="'Member Profile'" :slug="row.user_id" :row="row" :options="{ showLinks: true }" />
        <div slot-scope="{ row }" slot="expandedRow">
          <ul class="list-unstyled mb-0 pt-2">
            <li>
              <strong>Draft Name: </strong>
              <tableTextTemplate :text="row.draft_name" :row="row" :options="{ inline: true }" />
            </li>
            <li>
              <strong>Phone Number: </strong>
              <tableTextTemplate :text="row.phone" :row="row" :mobile="row.phone" :options="{ isMobile: true, inline: true }" />
            </li>
            <li>
              <strong>Suburb: </strong>
              <tableTextTemplate :text="row.suburb" :row="row" :options="{ inline: true }" />
            </li>
            <li>
              <strong>Zone: </strong>
              <tableTextTemplate :text="$store.state.listZones.filter(zone => zone.id === row.zone_id).length > 0 ? $store.state.listZones.filter(zone => zone.id === row.zone_id)[0].code : 'Unspecified'" :row="row" :options="{ inline: true }" />
            </li>
            <li>
              <strong>Judge Status: </strong>
              <tableTextTemplate :text="row.status" :row="row" :options="{ inline: true }"/>
            </li>
            <li>
              <div class="d-flex flex-wrap mt-2">
                <div class="mr-1">
                  <button
                    class="btn-default btn-small btn btn-sm btn-primary btn-actions mr-2 mb-2"
                    @click="approveApplication(row.id)"
                    :disabled="processing"
                  >
                    <div v-if="processing" class="d-flex align-items-center">
                      <div class="spinner-border spinner-border-sm text-light mr-2" role="status"></div>
                    </div>
                    <div v-else>
                      Approve
                    </div>
                  </button>
                </div>
                <div>
                  <button
                    class="btn-default btn-small btn btn-sm btn-primary btn-actions mr-2"
                    @click="denyApplication(row.id)"
                  >
                    <div v-if="processing" class="d-flex align-items-center">
                      <div class="spinner-border spinner-border-sm text-light mr-2" role="status"></div>
                    </div>
                    <div v-else>
                      Deny
                    </div>
                  </button>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </data-table>
    </div>
  </listing-layout>
</template>

<script>
import listingLayout from '@/components/ListingLayout'
import axios from 'axios'
import dataTable from '@/components/DataTable'
import tableTextTemplate from '@/components/DataTableFields/Text'

export default {

  name: "PendingExpressionInterest",
  components: {
    'listing-layout': listingLayout,
    'data-table': dataTable,
    tableTextTemplate
  },
  data() {
    return {
      success: localStorage.getItem("judge-app-status"),
      error: '',
      rows: [],
      columns: [
        {
          label: 'First Name',
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.first_name" :slug="row.user_id" :link="'Member Profile'" :row="row" :options="{ showLinks: true }" />`
          }),
          representedAs(row) { return `${row.first_name}` }
        },
        {
          label: 'Last Name',
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.last_name" :slug="row.user_id" :link="'Member Profile'" :row="row" :options="{ showLinks: true }" />`
          }),
          representedAs(row) { return `${row.last_name}` }
        },
        {
          label: 'Draft',
          field: 'draft_name',
          filterable: false,
          sortable: false,
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.draft_name" :row="row" />`
          }),
          representedAs: 'phone'
        },
        {
          label: 'Phone Number',
          field: 'contact',
          filterable: false,
          sortable: false,
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.phone" :row="row" :mobile="row.phone" :options="{ isMobile: true }" />`
          }),
          representedAs: 'phone'
        },
        {
          label: 'Suburb',
          field: 'suburb',
          filterable: false,
          sortable: false,
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.suburb" :row="row"/>`
          }),
          representedAs: 'suburb'
        },
        {
          label: 'Zone',
          field: 'zone_id',
          filterable: false,
          sortable: true,
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate class="js-parity" :data-parity="row.parity" :text="rowZone(row.zone_id)" :row="row" />`,
            methods: {
              rowZone(theID) {
                return this.$store.state.listZones.filter(zone => zone.id === theID).length ? this.$store.state.listZones.find(zone => zone.id === theID).code : 'Unspecified'
              }
            }
          })
        },
        {
          label: 'Judge Status',
          field: 'status',
          filterable: false,
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.status" :row="row"/>`
          }),
          representedAs: 'status'
        },
        {
          label: 'Actions',
          field: 'status',
          filterable: false,
          headerClass: 'd-none d-lg-table-cell table_header-actions',
          visible: true,
          component: ({
            props: ['row'],
            data() {
              return {
                processing: false
              }
            },
            methods: {
              approveApplication(applicationId) {
                this.processing = true
                axios.post(`${this.$api}/judges/draft-applications/${applicationId}/approve`).then((response) => {
                  if (response.data.status === 'success') {
                    // Done
                    localStorage.setItem("judge-app-status", response.data.message)
                    this.error = ''
                    this.processing = false
                    location.reload()
                  } else {
                    this.success = ''
                    this.error = 'Something went wrong. Please try again later.'
                  }
                }).catch(() => {
                  this.success = ''
                  this.error = 'There was a server error. Please try again later.'
                }).finally(() => this.processing = false)
              },
              denyApplication(applicationId) {
                this.processing = true
                axios.post(`${this.$api}/judges/draft-applications/${applicationId}/deny`).then((response) => {
                  if (response.data.status === 'success') {
                    // Done
                    localStorage.setItem("judge-app-status", response.data.message)
                    this.error = ''
                    this.processing = false
                    location.reload()
                  } else {
                    this.success = ''
                    this.error = 'Something went wrong. Please try again later.'
                  }
                }).catch(() => {
                  this.success = ''
                  this.error = 'There was a server error. Please try again later.'
                }).finally(() => this.processing = false)
              }
            },
            components: { tableTextTemplate },
            template: `
              <div class="d-flex flex-wrap mt-2">
                <div class="mr-1">
                  <button
                    class="btn-default btn-small btn btn-sm btn-primary btn-actions mr-2 mb-2"
                    @click="approveApplication(row.id)"
                    :disabled="processing"
                  >
                    <div v-if="processing" class="d-flex align-items-center">
                      <div class="spinner-border spinner-border-sm text-light mr-2" role="status"></div>
                    </div>
                    <div v-else>
                      Approve
                    </div>
                  </button>
                </div>
               <div>
                 <button
                   class="btn-default btn-small btn btn-sm btn-primary btn-actions mr-2"
                   @click="denyApplication(row.id)"
                    :disabled="processing"
                 >
                   <div v-if="processing" class="d-flex align-items-center">
                      <div class="spinner-border spinner-border-sm text-light mr-2" role="status"></div>
                    </div>
                    <div v-else>
                      Deny
                    </div>
                  </button>
               </div>
              </div>
            `
          }),
          representedAs: 'actions'
        }
      ],
      options: {
        filter: {},
        activeFilter: {},
        search: false,
        loaded: false
      },
      processing: false
    }
  },
  computed: {
    listZones() {
      return this.$store.state.listZones
    }
  },
  watch: {
    listZones() {
      if (this.listZones.length > 0) {
        this.rows.map((item) => {
          const tempItem = item
          tempItem.zone_name = this.listZones.filter(zone => zone.id === tempItem.zone_id).length > 0 ? this.listZones.filter(zone => zone.id === tempItem.zone_id)[0].code : 'Unspecified'
          return tempItem
        })
      }
    }
  },
  mounted() {
    axios.get(`${this.$api}/judges/draft-applications/pending-applications`).then((response) => {
      if (response.data.status === 'success') {
        this.error = ''
        const rows = response.data.data
        if (this.listZones.length > 0) {
          rows.map((item) => {
            const tempItem = item
            tempItem.zone_name = this.listZones.filter(zone => zone.id === tempItem.zone_id).length > 0 ? this.listZones.filter(zone => zone.id === tempItem.zone_id)[0].code : 'Unspecified'
            return tempItem
          })
        }
        this.rows = rows
        this.options.loaded = true
      } else {
        this.error = 'Unable to receive data from the server. Please reload the page.'
      }
    })
    localStorage.removeItem("judge-app-status")
  },
  methods: {
    approveApplication(applicationId) {
      this.processing = true
      axios.post(`${this.$api}/judges/draft-applications/${applicationId}/approve`).then((response) => {
        if (response.data.status === 'success') {
          // Done
          localStorage.setItem("judge-app-status", response.data.message)
          this.error = ''
          this.processing = false
          location.reload()
        } else if (response.data.status === 'judge_is_suspended' && response.data.errors) {
          this.success = ''
          this.errors = 'The judge is suspended'
        } else {
          this.success = ''
          this.error = 'Something went wrong. Please try again later.'
        }
      }).catch(() => {
        this.success = ''
        this.error = 'There was a server error. Please try again later.'
      }).finally(() => this.processing = false)
    },
    denyApplication(applicationId) {
      this.processing = true
      axios.post(`${this.$api}/judges/draft-applications/${applicationId}/deny`).then((response) => {
        if (response.data.status === 'success') {
          // Done
          localStorage.setItem("judge-app-status", response.data.message)
          this.error = ''
          this.processing = false
          location.reload()
        } else {
          this.success = ''
          this.error = 'Something went wrong. Please try again later.'
        }
      }).catch(() => {
        this.success = ''
        this.error = 'There was a server error. Please try again later.'
      }).finally(() => this.processing = false)
    }
  }
}
</script>

<style>
@media screen and (max-width: 1300px) {

  .btn-actions {
    max-width: 250px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Judges/Secretary/PendingExpressionInterest.vue